let accidentTypes = [
    {
        key: 'Accident/Near Miss', value: 'nearMiss'
    },
    {
        key: 'Close Call', value: 'closeCall'
    },
    {
        key: 'Good Practise', value: 'goodPractice'
    }
];

let reporterForms = [
    {
        key: 'Environmental Incident Reporting Form',
        value: 'envForm'
    },
    {
        key: 'Incident Reporting Form',
        value: 'irForm'
    }
];

let accidentRoles = [
    {
        key: 'Witness', value: 'witness'
    },
    {
        key: 'Reporters', value: 'reporter'
    },
    {
        key: 'Investigation Officer', value: 'officer'
    }
];

let assetStatus = [
    {
        key: 'Assigned', value: 'assigned'
    },
    {
        key: 'Unassigned', value: 'unassigned'
    }
];

let assignmentsStatus = [
    {
        id: '0', display: 'Assignment', status: 'Assignment', checked: true
    },
    {
        id: '1', display: 'Reading', status: 'Reading', checked: true
    },
];

let competencyType = [
    {
        key: 'Probationary', value: 'probationary'
    },
    {
        key: 'Intriem', value: 'intriem'
    }
];



let learning = [
    {
        learningOutcome: 'Understand environmental health and safety and how to promote health and safety in an engineering environment.',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    },
    {
        learningOutcome: 'Understand how to improve engineering efficiency and how engineering organisations are structured to ensure efficiency',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    },
    {
        learningOutcome: 'Understand how to prepare site for the installation of railway track and the health and safety requirements or rail engineering',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    },
    {
        learningOutcome: 'Understand how to prepare site for the installation of railway track and the health and safety requirements or rail engineering',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    },
    {
        learningOutcome: 'Understand how to construct railway track and the foundations required for regulation and compliance',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    },
    {
        learningOutcome: 'Understand how to construct railway track and the foundations required for regulation and compliance',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    },
    {
        learningOutcome: 'Understand how to install and maintain overhead lines on railway lines.',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    },
    {
        learningOutcome: 'Be able to maintain railway signalling systems on rail way lines',
        howToLearn: 'Via direct delivery and revisions sessions supported by the tutor. There will also be allocated revision and directed revision to support you in successfully achieving this unit Additional Tutor guidance:',
        assessment: 'Worksheets'
    }
];

let frequencyDay = [
    {
        id: '0', day: 'Sunday', checked: false
    },
    {
        id: '1', day: 'Monday', checked: false
    },
    {
        id: '2', day: 'Tuesday', checked: false
    },
    {
        id: '3', day: 'Wednesday', checked: false
    },
    {
        id: '4', day: 'Thursday', checked: false
    },
    {
        id: '5', day: 'Friday', checked: false
    },
    {
        id: '6', day: 'Saturday', checked: false
    }
];

let learnerAssignmentsL3 = [
    {
        id: '0', label: 'Completed', display: 'Completed', status: 'Completed', checked: false
    },
    {
        id: '0', label: 'Pending', display: 'Pending', status: 'Pending', checked: false
    },
    {
        id: '1', label: 'Re-Submitted', display: 'ReSubmitted', status: 'Re-Submitted', checked: false
    },
    {
        id: '2', label: 'Resubmit Requested', display: 'ResubmitRequested', status: 'Requested for Resubmission', checked: false
    },
    {
        id: '3', label: 'Submitted', display: 'Submitted', status: 'Submitted', checked: false
    },
];

let learnerAssignmentsL2 = [
    {
        id: '0', label: 'Completed', display: 'Completed', status: 'Completed', checked: false
    },
    {
        id: '0', label: 'Pending', display: 'Pending', status: 'Pending', checked: false
    },
    {
        id: '1', label: 'Re-Submitted', display: 'ReSubmitted', status: 'Re-Submitted', checked: false
    },
    {
        id: '2', label: 'Resubmit Requested', display: 'ResubmitRequested', status: 'Requested for Resubmission', checked: false
    },
    {
        id: '3', label: 'Submitted', display: 'Submitted', status: 'Submitted', checked: false
    },
    {
        id: '4', label: 'Saved', display: 'Saved', status: 'Saved', checked: false
    },
];

let monthArray = [
    {
        id: '0', name: 'January'
    },
    {
        id: '1', name: 'February'
    },
    {
        id: '2', name: 'March'
    },
    {
        id: '3', name: 'April'
    },
    {
        id: '4', name: 'May'
    },
    {
        id: '5', name: 'June'
    },
    {
        id: '6', name: 'July'
    },
    {
        id: '7', name: 'August'
    },
    {
        id: '8', name: 'September'
    },
    {
        id: '9', name: 'October'
    },
    {
        id: '10', name: 'November'
    },
    {
        id: '11', name: 'December'
    }
];

let userRoleList = [
    {
        key: "Medical Practitioner", value: "mp",
    },
    {
        key: "Trainer", value: "trainer",
    },
    {
        key: "IQA", value: "IQA",
    },
    {
        key: "Operatives", value: "operative",
    },
    { key: "Asset Manager", value: "assetManager" },
    { key: "Manager", value: "manager" }

];

let userFields = [
    // { id: '0', label: 'Primary/sub sponsor', display: 'Primary/sub sponsor', status: 'isPrimary', checked: false, isDisplay: true },
    {
        id: '1', label: 'Does person drive?', display: 'Does person drive?', status: 'isDrive', checked: false, isDisplay: true
    },
    {
        id: '2', label: 'Has own vehicle?', display: 'Has own vehicle?', status: 'isVehicle', checked: false, isDisplay: false
    },
    {
        id: '3', label: 'Assigned company vehicle?', display: 'Assigned company vehicle?', status: 'isAssigned', checked: false, isDisplay: false
    },
    {
        id: '4', label: 'Is this person in learning support?', display: 'Is this person in learning support?', status: 'isLearning', checked: false, isDisplay: true
    },
    {
        id: '5', label: 'Have any motoring convictions?', display: 'Have any motoring convictions?', status: 'isMotoring', checked: false, isDisplay: true
    },
];

let selects = [
    {
        key: "Primary", value: "primary",
    },
    {
        key: "Sub-sponsor", value: "subSponsor",
    },
    {
        key: "Not Applicable", value: "notApplicable",
    },
];

let licenseCategories = [
    {
        key: 'A', value: 'A', type: 'Motorbikes'
    },
    {
        key: 'AM', value: 'AM', type: '2 or 3 wheeled motors'
    },
    {
        key: 'B', value: 'B', type: 'Cars'
    },
    {
        key: 'B auto', value: 'Bauto', type: 'Automatic cars'
    },
    {
        key: 'B+E', value: 'B+E', type: 'Cat B + trailer'
    },
    {
        key: 'B1', value: 'B1', type: 'Light vehicles'
    },
    {
        key: 'C', value: 'C', type: 'Large lorries'
    },
    {
        key: 'C+E', value: 'C+E', type: 'Cat C + trailer'
    },
    {
        key: 'C1', value: 'C1', type: 'Lorries'
    },
    {
        key: 'C1+E', value: 'C1+E', type: 'Cat C1 + trailer'
    },
    {
        key: 'D', value: 'D', type: 'Bus'
    },
    {
        key: 'D+E', value: 'D+E', type: 'Cat D + trailer'
    },
    {
        key: 'D1', value: 'D1', type: 'Minibus'
    },
    {
        key: 'D1+E', value: 'D1+E', type: 'Cat D1 + trailer'
    },
    {
        key: 'F', value: 'F', type: 'Tractor'
    },
    {
        key: 'G', value: 'G', type: 'Road roller'
    },
    {
        key: 'H', value: 'H', type: 'Tracked vehicles'
    },
    {
        key: 'K', value: 'K', type: 'Pedestrian vehicles'
    },
    {
        key: 'Q', value: 'Q', type: '2 wheeled motors'
    },
];

let submissions = [
    {
        id: '0', label: 'Completed', display: 'Completed', status: 'Completed', checked: false
    },
    {
        id: '0', label: 'Pending', display: 'Pending', status: 'Pending', checked: false
    },
    {
        id: '1', label: 'Re-Submitted', display: 'ReSubmitted', status: 'Re-submitted', checked: false
    },
    {
        id: '2', label: 'Resubmit Requested', display: 'ResubmitRequested', status: 'Requested for Resubmission', checked: false
    },
    {
        id: '3', label: 'Submitted', display: 'Submitted', status: 'Submitted', checked: false
    },
    {
        id: '4', label: 'Saved', display: 'Saved', status: 'Submitted', checked: false
    },
];

let learnerTypes = [
    {
        key: "Classroom Training",
        value: "classroom training"
    },
    {
        key: "Role Play",
        value: "role play",
    },
    {
        key: "Coaching And Mentoring",
        value: "coaching and mentoring",
    },
    {
        key: "Simulation Exercises",
        value: "simulation exercises",
    },
    {
        key: "Online Learning",
        value: "online learning",
    },
    {
        key: "Work Shadowing",
        value: "work shadowing",
    },
    {
        key: "Manufacturer Training",
        value: "manufacturer training",
    },
    {
        key: "Industry Visits",
        value: "industry visits",
    },
    {
        key: "Self Study",
        value: "self study",
    },
    {
        key: "Assignment Completion",
        value: "assignment completion",
    },
    {
        key: "Other Details/Reflection",
        value: "other",
    }
];

let bpArray = [
    {
        id: 0,
        value: 'Full pass providing asymptomatic, Fail and refer to GP if symptomatic',
        checked: null
    },
    {
        id: 1,
        value: 'Full pass',
        checked: null
    },
    {
        id: 2,
        value: 'Full pass with advice',
        checked: null
    },
    {
        id: 3,
        value: '6 Month Medical Certificate and referral to GP',
        checked: null
    },
    {
        id: 4,
        value: 'Fail & referral to GP',
        checked: null
    }
];

let assignmentType = [
    {
        id: 1,
        text: 'File'
    },
    {
        id: 2,
        text: 'Knowledge Assessment'
    }
]

let quizAssignmentType =
    [
        {
            id: 2,
            text: 'Knowledge Assessment'
        }
    ]

let notQuizAssignmentType =
    [
        {
            id: 1,
            text: 'File'
        }
    ]

let learnerAllStatus =
    [
        { id: 1, name: 'Requested for Resubmission' },
        { id: 1, name: 'Completed' }
    ]
let categoryComeptency = [
    { value: 'Competences', viewValue: 'Competences' },
    { value: 'Drug & Alcohol', viewValue: 'Drug & Alcohol' },
    { value: 'Medical', viewValue: 'Medical' },
    { value: 'Other', viewValue: 'Other' }
]

let workloadFatiuges = [
    { value: 3, viewValue: 'Extremely demanding, no spare capacity' },
    { value: 2, viewValue: 'Moderately demanding, little spare capacity.' },
    { value: 1, viewValue: 'MedicalModerately undemanding, some spare capacity.' },
    { value: 0, viewValue: 'Extremely undemanding, lots of spare' }
]
let AttentionFatiuges = [
    { value: 3, viewValue: 'All or nearly all the time' },
    { value: 2, viewValue: 'Most of the time' },
    { value: 1, viewValue: 'Some of the time' },
    { value: 0, viewValue: 'Rarely or nearly none of the time' }
]

let metrialStatus = [
    { id: '0', display: 'Assignment', status: 'Assignment', checked: true },
    { id: '1', display: 'Reading', status: 'Reading', checked: true },
];



let shiftInformation = [
    { value: 'successful', key: 'Successful' },
    { value: 'unsuccessful', key: 'Unsuccessful' },
    { value: 'cancelled', key: 'Cancelled' },
]

let scoreControllerList = ['sittingandreading', 'watchingtv', 'inactive', 'passenger', 'circumstances', 'talkingtosomeone', 'alcohol', 'traffic']
let idConfirmList = ['Sentinel Card', 'Driving Licence', 'Passport', 'Company ID', 'Other'];
let noisyHobbiesList = ['Motor sports', 'Ride a motorcycle', 'DIY', 'Discos/loud music', 'Shooting', 'Other']
let yesNo = ['Yes', 'No']
let satisfactory = ['Satisfactory', 'Not Satisfactory']
let strength = ['Good', 'Fair', 'Poor']
let betterWorse = ['BETTER', 'WORSE']
let types = ['Glass wool / earplugs', 'inserts / earmuffs']
let normality = ['Normal', 'Abnormal']
let urinanalysis = ['NAD', '+', '++', '+++']
let ifYes = ['Blood Pressure', 'Smoking', 'Alcohol', 'BMI', 'Hearing']
let ifleafletsYes = ['Blood Pressure', 'Smoking', 'Alcohol', 'BMI', 'Hearing']
let mpResults = ['Level 1', 'Level 2', 'Level 3', 'Level 4', '6 month certificate', 'Colour vision deficient', 'Requires glasses', 'Referred to GP/optician', 'Referred to OH Physician', 'Temporary fail', 'Fail', 'Did not attend', 'D&A Only']
let mpFormParts = ['General Health', 'Vision Assessment', 'Color Vision', 'Hearing', 'Drugs', 'Alcohol', 'Uploaded to sentinel', 'Result'] //, "FITNESS ASSESSMENT SUMMARY" , 

let sessions = ['Classroom', 'Practical']
let classroomSessions = ['Course Induction', 'Railway Awareness Course', 'Safety Awareness', 'Manual Handling',
    'Track Construction & Components', 'Ballast Formation & Drainage', 'Track Geometry', 'Emergency First Aid',
    'Basic Fire Awareness', 'Emergency Phone Call', 'Emergency Protection of the Line',
    'Track Maintenance', 'Mechanised Maintenance', 'Off Track & Vegetation', 'Extremes of Weather', 'Portfolio Work', 'Underpinning Knowledge Questions', 'Technical Certificate', 'PTS', 'TIC']
let practicalSessions = ['Tools & Equipment', 'Ballast Profiling(Job No.1)', 'Fettling (Job No.2)', 'Sleeper Changing (Job No.3)', 'Transposing Rail (Job No.4)', 'Turning Rail (Job No. 5)', 'Changing Rail (Job No.6)', 'Sleeper Spacing / Squaring (Job No.7)', 'Lifting & Packing (Plain Line) (Job No.8)', 'Fishplate Maintenance (Job No.9)', 'Changing Chairs / Baseplates (Job No.10)', 'Track Inspection', 'S&C', 'Crossing Timber Change (Job No.11)', 'Changing Rails in S&C (Job No.12)', 'Lifting & Packing (S&C) (Job No.13)', 'Technical Certificate Practical', 'PTS Practical', 'TIC Practical']
let quizInputTypes = ['Text', 'Dropdown', 'Dragable Cards', 'Radio', 'Multiple Option', 'None']


let preferencesList = [
    { key: 'name', value: true, isDisabled: false },
    { key: 'email', value: true, isDisabled: false },
    { key: 'address', value: true, isDisabled: false },
    { key: 'terms', value: true, isDisabled: false },
    { key: 'actions', value: true, isDisabled: true, actionList: ['viewClient', 'editClient'] }
]
let competencyStatusList = [
    {
        id: '0', label: 'Probationary', display: 'Probationary', status: 'blue', checked: false
    },
    {
        id: '1', label: 'Interim', display: 'Interim', status: 'black', checked: false
    },
    {
        id: '2', label: '2 Weeks remaining for expiration', display: '2 Weeks remaining for expiration', status: 'red', checked: false
    },
    {
        id: '3', label: '12 Weeks remaining for expiration', display: '12 Weeks remaining for expiration', status: 'orange', checked: false
    },
    {
        id: '4', label: 'Expired', display: 'Expired', status: 'expired', checked: false
    },
    {
        id: '5', label: 'Others', display: 'Others', status: 'others', checked: false
    },
];


let timePeriodList = [
    {
        key: 'Week', value: 'weekly'
    },
    {
        key: 'Month', value: 'month'
    },
    {
        key: 'Quarter', value: 'quarter'
    },
    // {
    //     key: 'Half Yearly', value: 'sixmonth'
    // },
    {
        key: 'Year', value: 'year'
    },
]

let digitalFormList = [
    {
        title: 'All', value: 'all'
    },
    {
        title: 'ALO Coordinator Form', value: 'alo-coordinator'
    },
    {
        title: 'Site Inspection Form', value: 'site-inspection'
    },
    {
        title: 'Site Diary Form', value: 'site-diary'
    }
]
export const staticLocation = {
    latitude: 51.5072,
    longitude: 0.1276,
    address: '5 Crossway, Thamesmead, London, SE28 Thamesmead London England United Kingdom'
}

let formIdList = [
    {
        key: 'Sentinel Card', value: 'sentinelCard'
    },
    {
        key: 'Passport', value: 'passport'
    },
    {
        key: 'Company ID', value: 'companyID'
    },
    {
        key: 'Driving Licence', value: 'drivingLicence'
    },
    {
        key: 'Other - specify', value: 'other'
    }
]


let testReasonList = [
    {
        key: 'Pre-sponsorship', value: 'preSponsorship'
    },
    {
        key: 'Periodic', value: 'periodic'
    },
    {
        key: 'Unannounced', value: 'unannounced'
    },
    {
        key: 'For-Cause', value: 'forCause'
    }
]

let testReasonListPOCT = [
    {
        key: 'Pre-sponsorship', value: 'preSponsorship'
    },
    { key: 'Pre-employment', value: 'preEmployment' },
    {
        key: 'Periodic', value: 'periodic'
    },
    {
        key: 'Unannounced', value: 'unannounced'
    },
    {
        key: 'For-Cause', value: 'forCause'
    }
]

let jobRoleList = [
    "Administration / HSE Support",
    "Administration Manager",
    "Project Administration",
    "Project Manager",
    "Construction Manager",
    "Fitter/ Storeman",
    "Site Manager",
    "Engineer",
    "Site Manager/ Tech Officer",
    "Handback Engineer",
    "COSS/ SWL",
    "Trackman",
    "Assistant Engineer",
    "Engineering Supervisor"
]

let optionList = ['Yes', 'No', 'N/A']

let siteDairyManagerList = ['64873bb69634827c8f838d53', '64873bb69634827c8f838d09', '64873bb69634827c8f838ca3']

let operativeTimesheetModalData = {
    heading: "Send Timesheet for Approval",
    content: "Are you sure you want to submit timesheet for approval?",
    note: "You will not be able to edit your time logs once you submit them for approval. Only the timelogs with valid working hours will be considered.",
};
let adminTimesheetApprovalModalData = {
    heading: "Approve Timesheet",
    content: "Are you sure you want to approve timesheet of this job?",
    note: "After your approval, this timesheet and all it's logs will be considered final and locked.",
};

let adminTimesheetRejectionModalData = {
    heading: "Reject Timesheet",
    content: "Are you sure you want to Reject timesheet of this job?",
    note: "After your rejection, this timesheet and all it's logs will be rejected and sent back to the operative and they can put these logs up for approval again.",
};

let payType = [{ key: 'Hourly', value: 'hourly' }, { key: 'Day', value: 'day' }]
let payMethod = [{ key: 'CIS', value: 'cis' }, { key: 'PAYE', value: 'paye' }]
let payRate = [{ key: 'Midweek', value: 'midWeekRate' }, { key: 'Weekend', value: 'weekendRate' }, { key: '[Weekend] Handback', value: 'handBackRate' }, { key: 'Other', value: 'otherRate' }]


let countryList = [
    'England',
    'Scotland',
    'Wales',
    'Northern Ireland'
]

let religionList = [
    { key: 'Christian', value: 'christian' },
    { key: 'Muslim', value: 'muslim' },
    { key: 'Other Christian', value: 'otherChristian' },
    { key: 'Hindu', value: 'hindu' },
    { key: 'Roman Catholic', value: 'roman' },
    { key: 'Jewish', value: 'jewish' },
    { key: 'Methodist Church of Ireland', value: 'methodist' },
    { key: 'Sikh', value: 'sikh' },
    { key: 'Presbyterian Church of Ireland', value: 'presbyterian' },
    { key: 'Buddhist', value: 'buddhist' },
    { key: 'Church of Ireland', value: 'church' },
    { key: 'No Religion', value: 'noReligion' },
    { key: 'Church of Scotland', value: 'churchScotland' },
    { key: 'Other Religion', value: 'other' },
    { key: 'Prefer Not Say', value: 'notSay' }
]

let ageGroupList = [
    { key: '18 – 25', value: '1825' },
    { key: '26 – 35 ', value: '2635' },
    { key: '36 – 45', value: '3645' },
    { key: '46 – 55', value: '4655' },
    { key: '56 – 65 ', value: '5665' },
    { key: '66 and over', value: '66' },
    { key: 'Prefer Not Say', value: 'notSay' }
]


let ethnicList = [
    { key: 'Asian or Asian British – Bangladeshi', value: 'ethnic1' },
    { key: 'Asian or Asian British - Indian', value: 'ethnic2' },
    { key: 'Asian or Asian British – Pakistani', value: 'ethnic3' },
    { key: 'Asian or Asian British - Other', value: 'ethnic4' },
    { key: 'Black or Black British - Caribbean', value: 'ethnic5' },
    { key: 'Black or Black British - African', value: 'ethnic6' },
    { key: 'Black or Black British - Other', value: 'ethnic7' },
    { key: 'White and Asian', value: 'ethnic8' },
    { key: 'White and Black African', value: 'ethnic9' },
    { key: 'White and Black Caribbean', value: 'ethnic10' },
    { key: 'Chinese', value: 'ethnic11' },
    { key: 'White British', value: 'ethnic12' },
    { key: 'White Irish', value: 'ethnic13' },
    { key: 'White Other', value: 'ethnic14' },
    { key: 'Other', value: 'other' },
    { key: 'Prefer Not Say', value: 'notSay' }
]


let illnessePlaceHolderList = [
    'Stomach/bowels',
    'Back/neck',
    'Mental illness',
    'Bladder',
    'Ears',
    'Claustrophobia',
    'Kidney',
    'Eyes',
    'Vertigo',
    'Hernia',
    'Nose or throat',
    'Anxiety/stress',
    'Heart',
    'Lungs',
    'Nervous disorder',
    'Blood pressure',
    'Sinusitis',
    'Skin disease',
    'Blood disorder',
    'Tuberculosis',
    'Allergies',
    'Jaundice',
    'Fainting/dizzy spells',
    'Drug dependency',
    'Rheumatism/arthritis',
    'Headaches/migraines',
    'Alcohol dependency',
    'Tendons/ligaments/joints'
]


// ASSET PREFERENCE LIST


let assetPreferencesList = [
    { key: 'title', value: true, isDisabled: false },
    { key: 'id', value: true, isDisabled: false },
    { key: 'status', value: true, isDisabled: false },
    { key: 'name', value: true, isDisabled: false },
    { key: 'site', value: true, isDisabled: false },
    { key: 'registrationNumber', value: true, isDisabled: false },
    { key: 'manufacture', value: true, isDisabled: false },
    { key: 'model', value: true, isDisabled: false },
    { key: 'colour', value: true, isDisabled: false },
    { key: 'purchase', value: true, isDisabled: false },
    { key: 'VINNumber', value: true, isDisabled: false },
    { key: 'V5RefNumber', value: true, isDisabled: false },
    { key: 'leaseCompany', value: true, isDisabled: false },
    { key: 'aggrementNumber', value: true, isDisabled: false },
    { key: 'leaseCost', value: true, isDisabled: false },
    { key: 'totalPayable', value: true, isDisabled: false },
    { key: 'leaseStartDate', value: true, isDisabled: false },
    { key: 'leaseDuration', value: true, isDisabled: false },
    { key: 'leaseEndDate', value: true, isDisabled: false },
    { key: 'currentMileage', value: true, isDisabled: false },
    { key: 'mileageOnLease', value: true, isDisabled: false },
    { key: 'mileageRemaining', value: true, isDisabled: false },
    { key: 'insurance', value: true, isDisabled: false },
    { key: 'taxedUntilDate', value: true, isDisabled: false },
    { key: 'motUntilDate', value: true, isDisabled: false },
    { key: 'nextServiceDate', value: true, isDisabled: false },
    { key: 'action', value: true, isDisabled: true }
]

// FIXED ASSET MANAGEMENT ARRAY START

let fixedAssetForm = [
    { key: 'Inspection of Switches Secured Out of Use', value: 'form1', formName: 'inspectionSwitchesForm' },
    { key: 'Crossing Inspection Report', value: 'form2', formName: 'crossingInspectionReportForm' },
    { key: 'Level Crossing Inspection Record Form', value: 'form3', formName: 'levelCrossingInspectionForm' },
    { key: 'Inspection Form', value: 'form4', formName: 'fixedAssetInspectionForm' },
    // { key: 'Plant Inspection Form', value: 'form5', formName: 'jcb310rrForm' }
]

let plantAssetForm = [
    { key: 'Plant Inspection Form', value: 'form5', formName: 'jcb310rrForm' }
]

let crossingInspectionType = [
    { value: 'Facing', viewValue: 'Facing' },
    { value: 'Trailing', viewValue: 'Trailing' },
    { value: 'Single', viewValue: 'Single' },
]
let crossingOpation = [
    { value: 'yes', viewValue: 'Yes' },
    { value: 'no', viewValue: 'No' },
]
let crossingConstruction = [
    { value: 'Cast monobloc', viewValue: 'Cast monobloc' },
    { value: 'Cast centre block', viewValue: 'Cast centre block' },
    { value: 'Cast vee', viewValue: 'Cast vee' },
    { value: 'Machine nose block', viewValue: 'Machine nose block' },
    { value: 'Electro-slag welded vee', viewValue: 'Electro-slag welded vee' },
    { value: 'Fabricated', viewValue: 'Fabricated' }
]
let crossingDesign = [
    { value: 'Common', viewValue: 'Common' },
    { value: 'Obtuse', viewValue: 'Obtuse' },
    { value: 'Swing nose', viewValue: 'Swing nose' }
]
let crossingInstallationType = [
    { value: 'Plated', viewValue: 'Plated' },
    { value: 'Welded', viewValue: 'Welded' },
    { value: 'Part welded', viewValue: 'Part welded' },
]
let crossingSteelType = [
    { value: 'AMS', viewValue: 'AMS' },
    { value: 'Bainitic', viewValue: 'Bainitic' },
    { value: 'Normal grade', viewValue: 'Normal grade' },
    { value: 'Low alloy', viewValue: 'Low alloy' }
]


let fixedAssetList = [
    { key: 'title', columnValue: 'name', value: true, isDisabled: false },
    { key: 'created date', columnValue: 'name', value: true, isDisabled: false },
    { key: 'no of submissions', columnValue: 'name', value: true, isDisabled: false },
    { key: 'next inspection date', columnValue: 'name', value: true, isDisabled: false },
    { key: 'last inspection date', columnValue: 'name', value: true, isDisabled: false },
    { key: 'actions', columnValue: 'name', value: true, isDisabled: false, actionList: ['viewFixedAsset', 'editFixedAsset', 'deleteFixedAsset'] },
]


let plantAssetList = [
    { key: 'title', columnValue: 'name', value: true, isDisabled: false },
    { key: 'created date', columnValue: 'name', value: true, isDisabled: false },
    { key: 'no of submissions', columnValue: 'name', value: true, isDisabled: false },
    // { key: 'next inspection date', columnValue: 'name', value: true, isDisabled: false },
    // { key: 'last inspection date', columnValue: 'name', value: true, isDisabled: false },
    { key: 'fleet number', columnValue: 'name', value: true, isDisabled: false },
    { key: 'serial number', columnValue: 'name', value: true, isDisabled: false },
    { key: 'actions', columnValue: 'name', value: true, isDisabled: false, actionList: ['viewFixedAsset', 'editFixedAsset', 'deleteFixedAsset'] },
]



let defectCodeList = [
    { key: 'SC-01', value: 'sc01', type: 'Road and Rail Wheels' },
    { key: 'SC-02', value: 'sc02', type: 'Suspension and wheel support systems' },
    { key: 'SC-03', value: 'sc03', type: 'Brake systems' },
    { key: 'SC-04', value: 'sc04', type: 'Traction/ Driveline systems' },
    { key: 'SC-05', value: 'sc05', type: 'Speed indicating systems' },
    { key: 'SC-06', value: 'sc06', type: 'Inter -vehicle couplings and connections' },
    { key: 'SC-07', value: 'sc07', type: 'Fuel systems' },
    { key: 'SC-08', value: 'sc08', type: 'Power Units' },
    { key: 'SC-09', value: 'sc09', type: 'Lighting systems' },
    { key: 'SC-010', value: 'sc010', type: 'Cab conditions' },
    { key: 'SC-011', value: 'sc011', type: 'Electrical Systems' },
    { key: 'SC-012', value: 'sc012', type: 'Hydraulic Systems' },
    { key: 'SC-013', value: 'sc013', type: 'Safety interlock systems' },
    { key: 'SC-014', value: 'sc014', type: 'Operator Damage' },
    { key: 'SC-015', value: 'sc015', type: 'Pneumatics' },
    { key: 'SC-016', value: 'sc016', type: 'Warning Horn systems' },
    { key: 'SC-017', value: 'sc017', type: 'Rated Capacity Indicators' },
    { key: 'SC-018', value: 'sc018', type: 'structual integrity' },
    { key: 'SC-019', value: 'sc019', type: 'Sticker/Decals' },
    { key: 'SC-020', value: 'sc020', type: 'Panels' },
    { key: 'SC-021', value: 'sc021', type: 'Differentials/Transmission' },
    { key: 'SC-022', value: 'sc022', type: 'Circuit Protection devices' },
    { key: 'SC-023', value: 'sc023', type: 'Recovery systems' },
    { key: 'SC-024', value: 'sc024', type: 'Rail Gear' },
    { key: 'SC-025', value: 'sc025', type: 'Mechanical' },
    { key: 'SC-026', value: 'sc026', type: 'Lubrication' },
    { key: 'NSC-01', value: 'nsc01', type: 'Road and Rail Wheels' },
    { key: 'NSC-02', value: 'nsc02', type: 'Suspension and wheel support systems' },
    { key: 'NSC-03', value: 'nsc03', type: 'Brake systems' },
    { key: 'NSC-04', value: 'nsc04', type: 'Traction/ Driveline systems' },
    { key: 'NSC-05', value: 'nsc05', type: 'Speed indicating systems' },
    { key: 'NSC-06', value: 'nsc06', type: 'Inter -vehicle couplings and connections' },
    { key: 'NSC-07', value: 'nsc07', type: 'Fuel systems' },
    { key: 'NSC-08', value: 'nsc08', type: 'Power Units' },
    { key: 'NSC-09', value: 'nsc09', type: 'Lighting systems' },
    { key: 'NSC-010', value: 'nsc010', type: 'Cab conditions' },
    { key: 'NSC-011', value: 'nsc011', type: 'Electrical Systems' },
    { key: 'NSC-012', value: 'nsc012', type: 'Hydraulic Systems' },
    { key: 'NSC-013', value: 'nsc013', type: 'Safety interlock systems' },
    { key: 'NSC-014', value: 'nsc014', type: 'Operator Damage' },
    { key: 'NSC-015', value: 'nsc015', type: 'Pneumatics' },
    { key: 'NSC-016', value: 'nsc016', type: 'Warning Horn systems' },
    { key: 'NSC-017', value: 'nsc017', type: 'Rated Capacity Indicators' },
    { key: 'NSC-018', value: 'nsc018', type: 'structual integrity' },
    { key: 'NSC-019', value: 'nsc019', type: 'Sticker/Decals' },
    { key: 'NSC-020', value: 'nsc020', type: 'Panels' },
    { key: 'NSC-021', value: 'nsc021', type: 'Differentials/Transmission' },
    { key: 'NSC-022', value: 'nsc022', type: 'Circuit Protection devices' },
    { key: 'NSC-023', value: 'nsc023', type: 'Recovery systems' },
    { key: 'NSC-024', value: 'nsc024', type: 'Rail Gear' },
    { key: 'NSC-025', value: 'nsc025', type: 'Mechanical' },
    { key: 'NSC-026', value: 'nsc026', type: 'Lubrication' }
]


let submissionType = [
    { key: 'Weekly', value: 'weekly' },
    { key: 'Monthly', value: 'monthly' },
    { key: 'Six Monthly', value: 'sixmonthly' },
    { key: 'Twelve Monthly', value: 'twelvemonthly' },
]

export const fixedAssetLists = fixedAssetList
export const crossingInspectionTypes = crossingInspectionType
export const crossingOpations = crossingOpation
export const crossingConstructions = crossingConstruction
export const crossingDesigns = crossingDesign
export const crossingInstallationTypes = crossingInstallationType
export const crossingSteelTypes = crossingSteelType
export const fixedAssetForms = fixedAssetForm
export const plantAssetForms = plantAssetForm
export const plantAssetLists = plantAssetList
export const defectCodeLists = defectCodeList
export const submissionTypes = submissionType

// FIXED ASSET MANAGEMENT ARRAY END

export const assetPreferencesLists = assetPreferencesList;
export const illnessePlaceHolderLists = illnessePlaceHolderList
export const ethnicLists = ethnicList
export const ageGroupLists = ageGroupList
export const religionLists = religionList
export const countryLists = countryList
export const jobRoleLists = jobRoleList
export const testReasonListsPOCT = testReasonListPOCT;
export const testReasonLists = testReasonList;
export const formIdLists = formIdList;
export const payRates = payRate;
export const payMethods = payMethod;
export const payTypes = payType;
export const _operativeTimesheetModalData = operativeTimesheetModalData;
export const _adminTimesheetApprovalModalData = adminTimesheetApprovalModalData;
export const _adminTimesheetRejectionModalData = adminTimesheetRejectionModalData;
export const siteDairyManagerLists = siteDairyManagerList;
export const optionLists = optionList;
export const digitalFormLists = digitalFormList;
export const accidentType = accidentTypes;
export const reporterForm = reporterForms;
export const accidentUserRoles = accidentRoles;
export const assetStatusType = assetStatus;
export const assignmentStatus = assignmentsStatus;
export const learningArray = learning;
export const frequencyDays = frequencyDay;
export const learnerAssignmentL2 = learnerAssignmentsL2;
export const learnerAssignmentL3 = learnerAssignmentsL3;
export const months = monthArray;
export const userRolesList = userRoleList;
export const usersFields = userFields;
export const select = selects;
export const licenseCategory = licenseCategories;
export const statusOfAssignment = submissions;
export const learnerType = learnerTypes;
export const bpForm2Array = bpArray;
export const assignmentTypes = assignmentType
export const quizAssignmentTypes = quizAssignmentType
export const notQuizAssignmentTypes = notQuizAssignmentType
export const learnersAllStatus = learnerAllStatus
export const categoryComeptences = categoryComeptency
export const scoreControllerListArray = scoreControllerList
export const idConfirmListArray = idConfirmList
export const noisyHobbiesListArray = noisyHobbiesList
export const yesNoArray = yesNo
export const satisfactoryArray = satisfactory
export const strengthArray = strength
export const betterWorseArray = betterWorse
export const typesArray = types
export const normalityArray = normality
export const urinanalysisArray = urinanalysis
export const ifYesArray = ifYes
export const ifleafletsYesArray = ifleafletsYes
export const medicalResultArray = mpResults
export const mpFormPartsArray = mpFormParts
export const sessionsArray = sessions
export const classroomSessionsArray = classroomSessions
export const practicalSessionsArray = practicalSessions
export const quizInputTypesArray = quizInputTypes
export const metrialStatusArray = metrialStatus
export const competencyTypes = competencyType
export const shiftInfo = shiftInformation
export const workloadFatiuge = workloadFatiuges
export const AttentionFatiuge = AttentionFatiuges
export const preferencesLists = preferencesList
export const competencyStatusLists = competencyStatusList
export const timePeriodLists = timePeriodList